import { db, auth } from '../firebase/firebase-config';
import { collection, addDoc, query, where, getDocs, serverTimestamp, doc, setDoc } from 'firebase/firestore';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';

export const saveReport = async (report, companyName) => {
  try {
    console.log('Starting to save report for:', companyName);
    const reportsRef = collection(db, 'reports');
    
    // Sjekk at alle nødvendige data er tilgjengelig
    if (!report || !companyName) {
      console.error('Missing required data:', { report, companyName });
      throw new Error('Missing required data');
    }

    const reportData = {
      ...report,
      companyName,
      createdAt: new Date().toISOString(),
      status: 'published'
    };

    console.log('Attempting to save report data:', reportData);
    
    const docRef = await addDoc(reportsRef, reportData);
    console.log('Report successfully saved with ID:', docRef.id);
    return true;
  } catch (error) {
    console.error('Detailed error saving report:', error);
    throw error; // La AdminDashboard håndtere feilen
  }
};

export const getCompanyReports = async (companyName) => {
  try {
    console.log('Fetching reports for:', companyName);
    const reportsRef = collection(db, 'reports');
    const q = query(reportsRef, where('companyName', '==', companyName));
    const querySnapshot = await getDocs(q);
    
    const reports = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    console.log('Found reports:', reports);
    return reports;
  } catch (error) {
    console.error('Error getting reports:', error);
    return [];
  }
};

export const validateInvitationCode = async (code) => {
  try {
    // Format invitation code as email (code@purepaths.com)
    const email = `${code}@purepaths.com`;
    const password = code; // Using the code as password

    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Get custom claims or user metadata
    const idTokenResult = await user.getIdTokenResult();
    
    return {
      valid: true,
      companyId: idTokenResult.claims.companyId || user.uid,
      companyName: idTokenResult.claims.companyName || 'Default Company'
    };
  } catch (error) {
    console.error('Error validating invitation code:', error);
    return { 
      valid: false, 
      message: 'Invalid invitation code'
    };
  }
};

export const saveChatLog = async (userEmail, message, response) => {
  try {
    const chatLogsRef = collection(db, 'chatLogs');
    const company = userEmail.includes('@ppbaker.com') ? 'Baker Hughes Stord' : 
                   userEmail.includes('@pptess.com') ? 'Tess Stord' : 
                   'Unknown';
    
    await addDoc(chatLogsRef, {
      userEmail,
      company,
      message,
      response,
      timestamp: serverTimestamp(),
      platform: 'web'
    });

    console.log('Chat log saved successfully');
  } catch (error) {
    console.error('Error saving chat log:', error);
  }
};

export const createHRAccount = async (email, password, companyName, role) => {
  try {
    // Opprett bruker i Firebase Auth
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Lagre brukerdata i Firestore
    await setDoc(doc(db, 'users', user.uid), {
      email,
      companyName,
      role: 'hr',
      createdAt: new Date().toISOString()
    });

    return {
      success: true,
      message: 'HR-konto opprettet vellykket'
    };
  } catch (error) {
    console.error('Error creating HR account:', error);
    throw new Error(`Kunne ikke opprette HR-konto: ${error.message}`);
  }
};

export const signInHR = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    
    // Legg til companyName basert på email
    let companyName;
    if (email === 'hr.baker@ppbaker.com') {
      companyName = 'Baker Hughes Stord';
    }
    // ... andre HR-brukere ...

    // Lagre brukerinfo i localStorage
    const userData = {
      uid: userCredential.user.uid,
      email: userCredential.user.email,
      companyName: companyName,
      isHR: true
    };
    
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('userToken', await userCredential.user.getIdToken());

    return userData;
  } catch (error) {
    console.error('Error signing in HR:', error);
    throw new Error(`Innlogging feilet: ${error.message}`);
  }
};